import { FormControl, InputLabel } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

const StatusList = [
	{ code: "All", status: "All" },
	{ code: "O", status: "Open" },
	{ code: "S", status: "Submitted" },
];

export const StatusFilter = ({
	value,
	onChange,
}: {
	value: string;
	onChange: (value: "All" | "A" | "O" | "S") => void;
}) => {
	return (
		<FormControl variant="outlined" size="small" fullWidth>
			<InputLabel>Status</InputLabel>
			<Select
				variant="outlined"
				label="Status"
				value={value}
				onChange={(e) => onChange(e.target.value as "All" | "O" | "S")}
				displayEmpty
			>
				{StatusList.map((status) => (
					<MenuItem key={`status-${status?.code}`} value={status?.code}>
						{status?.status}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
};
